export default __webpack_public_path__ + "static/media/top.663eeebc.png";